module.exports = __webpack_public_path__ + "img/to-card.6c6534b1.svg";